import { Controller } from "@hotwired/stimulus";
import Inputmask from "inputmask";

export default class extends Controller {
  static targets = ["iban", "bicField"];

  // Country codes that not require manual BIC entry
  static COUNTRIES_NOT_REQUIRING_MANUAL_BIC = ["DE", "AT"];

  connect() {
    this.initializeMask();
    this.checkBicRequired();
  }

  initializeMask() {
    if (this.hasIbanTarget) {
      this.destroyMaskIfExists();

      // IBAN format: 2 letters (country code) + numbers only
      // Example: DE89 3704 0044 0532 0130 00
      const maskConfig = {
        mask: "AA99[ 9999][ 9999][ 9999][ 9999][ 9999][ 9999][ 99]",
        definitions: {
          "A": { validator: "[A-Za-z]", cardinality: 1, casing: 'upper' },
          "9": { validator: "[0-9]", cardinality: 1 }
        },
        placeholder: '',  // No placeholder characters
        greedy: false,
        showMaskOnHover: false,
        showMaskOnFocus: false,
        clearIncomplete: false,
        autoUnmask: true,
        removeMaskOnSubmit: true,
        skipOptionalPartCharacter: ' '
      };

      this.mask = new Inputmask(maskConfig);
      this.mask.mask(this.ibanTarget);

    }
  }

  destroyMaskIfExists() {
    if (this.ibanTarget.inputmask) {
      this.ibanTarget.inputmask.remove();
    }
  }

  disconnect() {
    this.destroyMaskIfExists();
  }

  checkBicRequired() {
    if (!this.hasBicFieldTarget) return;

    const iban = this.ibanTarget.value.replace(/\s/g, '').toUpperCase();
    const countryCode = iban.substring(0, 2);
    const hasFullCountryCode = /^[A-Z]{2}/.test(countryCode);

    if (hasFullCountryCode && !this.constructor.COUNTRIES_NOT_REQUIRING_MANUAL_BIC.includes(countryCode)) {
      this.bicFieldTarget.classList.remove("hidden");
    } else {
      this.bicFieldTarget.classList.add("hidden");
    }
  }
}
